export const ProfileBlacklistRels = {
    GetProfileBlacklists: 'getProfileBlacklists',
    GetProfileBlacklist: 'getProfileBlacklist',
    GetProfileBlacklistProfiles: 'getProfileBlacklistProfiles',
    DeleteBlacklistedProfiles: 'deleteBlacklistedProfiles',
    CreateProfileBlacklist: 'createProfileBlacklist',
    UpdateProfileBlacklist: 'updateProfileBlacklist',
    DeleteProfileBlacklist: 'deleteProfileBlacklist'
};
